import type { TOC } from '@ember/component/template-only';
import { t } from 'ember-intl';
import { pageTitle } from 'ember-page-title';
import { eq } from 'ember-truth-helpers';
import LoginConfirmationCode from 'frontend-payments/components/login/confirmation-code';
import LoginEmailVerification from 'frontend-payments/components/login/email-verification';
import type LoginController from 'frontend-payments/controllers/login';
import { contextualPageTitle } from 'frontend-utils';
import { LoginWrapper } from 'password-form';

interface LoginSignature {
  Args: {
    controller: LoginController;
  };
}

<template>
  {{pageTitle (contextualPageTitle (t "login.sign_in"))}}

  <LoginWrapper>
    {{#if (eq @controller.currentStep "email")}}
      <LoginEmailVerification
        @onEmailVerified={{@controller.onEmailVerified}}
      />
    {{else}}
      <LoginConfirmationCode @email={{@controller.userEmail}} />
    {{/if}}
  </LoginWrapper>
</template> satisfies TOC<LoginSignature>;
